// export const graphqlUrl = "http://3.36.22.165:4000/graphql";
export const graphqlUrl = "https://api.care-korea.kr/graphql";
